import React from 'react';
import classnames from 'classnames';
import { GooglePay } from '../../../payment-methods/GooglePay';
import { ApplePay } from '../../../payment-methods/ApplePay';
import { DH } from '../../../../utils/dataHooks';
import { PayPalElem, PayPalElems } from '../../elements';
import { HorizontalLayoutDivider } from '../HorizontalLayoutDivider';
import { t } from '../../../../utils/i18n';
import s from '../../styles.scss';

export interface Props {
  availablePmsList: {
    googlePay: boolean;
    applePay: boolean;
    payPal: string[];
  };
  /**
   * @deprecated horizontalLayoutHeaderClassName - is not in use.
   */
  horizontalLayoutHeaderClassName: string;
  horizontalLayoutDividerClassName: string;
}

export const HorizontalListView: React.FC<Props> = (props) => {
  const { availablePmsList, horizontalLayoutDividerClassName } = props;
  const [mainPayPalSource, ...restPayPalSources] = availablePmsList.payPal;

  return (
    <>
      <fieldset data-hook={DH.Widget.HorizontalLayoutFieldset} className={classnames(s.fieldset)}>
        <legend className={s.legend}>{t('horizontalLayout.header')}</legend>
        <div data-hook={DH.Widget.PMList} className={classnames(s.layout, s.horizontal)}>
          {availablePmsList.applePay && (
            <div className={s.layoutItem}>
              <ApplePay />
            </div>
          )}
          {mainPayPalSource && <PayPalElem fundingSource={mainPayPalSource} mainSource={true}></PayPalElem>}
          {restPayPalSources && <PayPalElems fundingSources={restPayPalSources}></PayPalElems>}
          {availablePmsList.googlePay && (
            <div className={s.layoutItem}>
              <GooglePay />
            </div>
          )}
        </div>
      </fieldset>
      <HorizontalLayoutDivider className={horizontalLayoutDividerClassName} />
    </>
  );
};
